<template>
  <div class="xv_view" id="Employee_view">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">{{ this.name }}</label>
      </div>
      <div class="xv_actions">
        <span>Status :</span>
        <span class="main_status_1">Ok</span>
        <!-- <span class="main_status_2">Block</span>
        <span class="main_status_3">Work from home</span>-->
      </div>
    </div>
    <div class="xv_tabs">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Profile" active>
            <div class="tab_profile">
              <div class="row">
                <div class="col-7">
                  <div class="pro_section">
                    <label>Employee Id</label>
                    <input type="text" value="Joseph Davis" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Email Id</label>
                    <input
                      type="text"
                      value="josephdavis@gmail.com"
                      :disabled="profile_edit == false"
                    />
                  </div>
                  <div class="pro_section">
                    <label>Mobile number</label>
                    <input type="text" value="+1-202-555-0135" :disabled="profile_edit == false" />
                  </div>

                  <div class="pro_section">
                    <label>Office</label>
                    <select name id :disabled="profile_edit == false">
                      <option value="1">Microsoft</option>
                      <option value="1" selected>Apple</option>
                      <option value="1">Nestle</option>
                      <option value="1">Alphabet</option>
                      <option value="1">Facebook</option>
                      <option value="1">Alibaba</option>
                      <option value="1">Tencent</option>
                    </select>
                  </div>
                  <div class="pro_section">
                    <label>Role</label>

                    <select name id :disabled="profile_edit == false">
                      <option value="1">Super admin</option>
                      <option value="1">Office admin</option>
                      <option value="1">Bio security</option>
                      <option value="1">Employee</option>
                    </select>
                  </div>
                  <div class="pro_section">
                    <label>Joined On</label>
                    <input type="text" value="5th March,2020 10.00 AM PST" disabled />
                  </div>
                  <div class="pro_section">
                    <label>Last Logged In</label>
                    <input type="text" value="7th March,2020 10.00 AM PST" disabled />
                  </div>

                  <div class="row pro_section">
                    <div class="col-4">
                      <label>Status</label>
                      <select name id :disabled="profile_edit == false">
                        <option value="1">Ok</option>
                        <option value="2">Block</option>
                        <option value="2">Work from home</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label>Comments</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                  </div>
                </div>

                <div class="col-5 text-right">
                  <div v-if="profile_edit == false">
                    <button class="pro_btn m_r sec_btn" @click="profile_edit = true">
                      <span class="mdi mdi-pencil"></span>
                    </button>
                    <button class="pro_btn sec_btn" @click="delete_popup()">
                      <span class="mdi mdi-trash-can"></span>
                    </button>
                  </div>

                  <div v-if="profile_edit == true">
                    <button class="pro_btn m_r save save_btn" @click="profile_edit = false">Save</button>
                    <button class="pro_btn cancel delete_btn" @click="profile_edit = false">Cancel</button>
                  </div>

                  <div class="profile_preview">
                    <div class="pro_pic">
                      <img src="../../../../assets/users/1.jpg" alt />
                    </div>
                    <div class="meta_info">
                      <span>Other options are Not Onboarded</span>
                    </div>
                    <div class="pro_infos">
                      <div class="pro_info score">
                        <div class="value">
                          <span>98</span>
                        </div>
                        <div class="title">
                          <span>Health score</span>
                        </div>
                      </div>
                      <div class="pro_info status">
                        <div class="value">
                          <span>Ok</span>
                        </div>
                        <div class="title">
                          <span>Today Health Status</span>
                        </div>
                      </div>
                      <div class="pro_info status">
                        <div class="value">
                          <span>Ok</span>
                        </div>
                        <div class="title">
                          <span>Long Term Health Status</span>
                        </div>
                      </div>
                      <div class="pro_info declaration">
                        <div class="value" @click="view_declaration()">
                          <span>
                            <span class="mdi mdi-clipboard-text-outline"></span>9th March,2020
                          </span>
                        </div>
                        <div class="title">
                          <span>Declaration</span>
                        </div>
                      </div>
                      <div class="pro_info alert">
                        <div class="value">
                          <span>2</span>
                        </div>
                        <div class="title">
                          <span>Critical Alert</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Alerts">
            <div class="xv_table">
              <div class="xv_table_title">
                <div>
                  <span>Alerts(5) this week</span>
                </div>
                <div>
                  <button class="sec_btn" @click="table_filter_a()">
                    Filter
                    <span class="mdi mdi-filter-menu"></span>
                  </button>
                </div>
              </div>

              <div class="filter_wrap">
                <div class="left_filter" v-if="left_filter_a == true">
                  <div class="header_section top">
                    <div>
                      <span class="main_title">
                        Filter
                        <span class="mdi mdi-filter-menu"></span>
                      </span>
                    </div>
                    <div>
                      <span class="option">Reset</span>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Date</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="range"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Locations</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <multiselect
                        v-model="multiselect"
                        :options="[
                          'Borad room',
                          'Meeting room',
                          'Food court',
                          'Parking'
                        ]"
                        :multiple="true"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Type</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">High Temperature</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Low XV Score</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Quarantine Contact</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-8" name="checkbox-8"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Traveled to Korea</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="alerts_table">
                  <thead>
                    <tr>
                      <th style>Date/Time</th>
                      <th style="text-align:center">Locations</th>
                      <th style="text-align:center">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Board Room</span>
                      </td>
                      <td>
                        <span class="alert_1" id="type_ht_2">High Temperature</span>
                      </td>
                      <b-popover target="type_ht_2" triggers="hover" placement="bottom">
                        Sed eu justo ullamcorper, hendrerit urna quis, varius
                        lorem.
                      </b-popover>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Meeting Room</span>
                      </td>
                      <td>
                        <span class="alert_2" id="type_ls_1">Low XV Score</span>
                      </td>
                      <b-popover target="type_ls_1" triggers="hover" placement="bottom">
                        Sed eu justo ullamcorper, hendrerit urna quis, varius
                        lorem.
                      </b-popover>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Food court</span>
                      </td>
                      <td>
                        <span class="alert_3" id="type_qc_2">Quarantine Close Contact</span>
                        <b-popover target="type_qc_2" triggers="hover" placement="bottom">
                          Sed eu justo ullamcorper, hendrerit urna quis, varius
                          lorem.
                        </b-popover>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Parking</span>
                      </td>
                      <td>
                        <span class="alert_1" id="type_tk_1">Traveled to Korea</span>
                        <b-popover target="type_tk_1" triggers="hover" placement="bottom">
                          Sed eu justo ullamcorper, hendrerit urna quis, varius
                          lorem.
                        </b-popover>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>

          <b-tab title="Health Declaration">
            <div class="xv_table">
              <div class="xv_table_title">
                <div>
                  <span>Declarations (5) for this week</span>
                </div>
                <div>
                  <button class="sec_btn" @click="table_filter_hd()">
                    Filter
                    <span class="mdi mdi-filter-menu"></span>
                  </button>
                </div>
              </div>

              <div class="filter_wrap">
                <div class="left_filter" v-if="left_filter_hd == true">
                  <div class="header_section top">
                    <div>
                      <span class="main_title">
                        Filter
                        <span class="mdi mdi-filter-menu"></span>
                      </span>
                    </div>
                    <div>
                      <span class="option">Reset</span>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Date</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="range"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Health</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                        </div>
                        <div class="check_label">
                          <span>Ok</span>
                        </div>
                      </div>

                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Diagnosed</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-4" name="checkbox-4"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Suspect</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Travel History</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Ok</span>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Violation</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Quaratine</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Ok</span>
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Quaratine</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="e_health_table">
                  <thead>
                    <tr>
                      <th style>Date</th>
                      <th style="text-align:center">Health</th>
                      <th style="text-align:center">Travel History</th>
                      <th style="text-align:center">Quaratine</th>
                      <th style="text-align:center">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span>Ok</span>
                      </td>
                      <td>
                        <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Activity">
            <div class="xv_table">
              <div class="xv_table_title">
                <div>
                  <span>Activity (5) for today</span>
                </div>
                <div>
                  <button class="sec_btn" @click="table_filter()">
                    Filter
                    <span class="mdi mdi-filter-menu"></span>
                  </button>
                </div>
              </div>

              <div class="filter_wrap">
                <div class="left_filter" v-if="left_filter == true">
                  <div class="header_section top">
                    <div>
                      <span class="main_title">
                        Filter
                        <span class="mdi mdi-filter-menu"></span>
                      </span>
                    </div>
                    <div>
                      <span class="option">Reset</span>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Date</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="range"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                            class: 'picker_input',
                            placeholder: 'Select dates',
                            readonly: true
                          }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Marker</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <input type="text" placeholder="Marker" />
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Office</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                        </div>
                        <div class="check_label">
                          <span>Main Office</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-2" name="checkbox-2"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Home</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Parking</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Locations</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                        </div>
                        <div class="check_label">
                          <span>Board Room</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-2" name="checkbox-2"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Meeting Room</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Food court</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-4" name="checkbox-4"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Parking</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Severity</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Severity 1</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Severity 2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="section">
                    <div class="header_section">
                      <div>
                        <span class="title">Type</span>
                      </div>
                      <div>
                        <span class="option">Clear</span>
                      </div>
                    </div>

                    <div class="content">
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">High Temperature</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-6" name="checkbox-6"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Low XV Score</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-7" name="checkbox-7"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Quarantine Contact</span>
                        </div>
                      </div>
                      <div class="filter_checkbox">
                        <div class="check">
                          <b-form-checkbox id="checkbox-8" name="checkbox-8"></b-form-checkbox>
                        </div>
                        <div>
                          <span class="check_label">Traveled to Korea</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="e_activity_table">
                  <thead>
                    <tr>
                      <th style>Date</th>
                      <th style="text-align:center">Office</th>
                      <th style="text-align:center">Location</th>
                      <th style="text-align:center">Type</th>
                      <th style="text-align:center">Source</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Main Office</span>
                      </td>
                      <td>
                        <span>Meeting Room 2</span>
                      </td>
                      <td>
                        <span>
                          <span class="mdi mdi-thermometer"></span> 34.3
                        </span>
                      </td>
                      <td>Partner Security</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Main Office</span>
                      </td>
                      <td>
                        <span>Food court 1</span>
                      </td>
                      <td>
                        <span>Check In</span>
                      </td>
                      <td>Auto</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Home</span>
                      </td>
                      <td>
                        <span>Home</span>
                      </td>
                      <td>
                        <span>Health Declaration</span>
                      </td>
                      <td>Security</td>
                    </tr>
                    <tr>
                      <td>
                        <span>02-Jan-2020 10:30am</span>
                      </td>
                      <td>
                        <span>Parking</span>
                      </td>
                      <td>
                        <span>Board Room 2</span>
                      </td>
                      <td>
                        <span>
                          <span class="mdi mdi-thermometer"></span> 34.0
                        </span>
                      </td>
                      <td>Security</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <template v-slot:tabs-end></template>
        </b-tabs>
      </div>
    </div>
    <!-- Delete popup -->
    <modal name="delete_popup" transition="pop-out" :width="450" height="auto">
      <deletePopup delete_text="Do you really want to delete this employee? This cannot be undone."></deletePopup>
    </modal>
    <!-- Declaration preview -->
    <modal
      name="declaration_preview"
      transition="pop-out"
      :width="720"
      height="auto"
      :scrollable="true"
    >
      <declarationPreview></declarationPreview>
    </modal>
  </div>
</template>

<script>
import deletePopup from "../../../layout/delete_popup/delete_popup.vue";
import declarationPreview from "../../health_declaration/declaration_preview/declaration_preview.vue";

export default {
  name: "Employee_view",
  components: {
    deletePopup,
    declarationPreview
  },
  data() {
    return {
      name: "",
      left_filter: false,
      left_filter_hd: false,
      left_filter_a: false,
      profile_edit: false,
      multiselect: null
    };
  },
  // watch: {
  //   "$route.params.id": function() {
  //     this.name = this.$route.params.id.slice(1);
  //   }
  // },
  created() {
    this.name = this.$route.params.id.slice(1);
  },
  methods: {
    delete_popup: function() {
      this.$modal.show("delete_popup");
    },
    table_filter: function() {
      if (this.left_filter == false) {
        this.left_filter = true;
      } else {
        this.left_filter = false;
      }
    },
    table_filter_hd: function() {
      if (this.left_filter_hd == false) {
        this.left_filter_hd = true;
      } else {
        this.left_filter_hd = false;
      }
    },
    table_filter_a: function() {
      if (this.left_filter_a == false) {
        this.left_filter_a = true;
      } else {
        this.left_filter_a = false;
      }
    },
    view_declaration: function() {
      this.$modal.show("declaration_preview");
    }
  }
};
</script>
